import { jsx as r } from "react/jsx-runtime";
import { c as t } from "./clsx.OuTLNxxd.js";
const m = ({ className: o = "", name: s }) => /* @__PURE__ */ r("span", { className: t(`customicon-${s}`, o), "aria-hidden": "true" });
export {
  m as C
};
